module.exports = __webpack_public_path__ + "static/media/banner_portal.fc45cc2a.png";